import './CtaSupport.scss'

import {Controller, useForm} from 'react-hook-form'
import {LinkType, WysiwygType} from '../../../types'
import React, {Fragment, useState} from 'react'

import {Dropdown} from '../../ui/Dropdown'
import {LinkEntryType} from '../../../campagne/types'
import {Theme} from '../../../views/Theme'
import {style} from '../../../util/style'
import {useHistory} from 'react-router'
import {useTranslation} from '../../../util/i18n'

const styles = style('ctasupport')

export type CtaSupportType = {
	prices?: Array<string>
	title_overwrite?: string
	text?: WysiwygType
	link?: LinkType
	donation_link: LinkEntryType
}

export const CtaSupport: React.FC<CtaSupportType & {container?: boolean}> = ({
	container,
	prices,
	title_overwrite,
	text,
	link,
	donation_link
}) => {
	const t = useTranslation().cta.support
	const ContainerTag = container ? Theme.Container : Fragment
	const priceName = 'price'
	const priceOptions = []
	prices?.forEach(function (price, i) {
		this[i] = {path: price, title: '€' + price}
	}, priceOptions)
	const methods = useForm({
		defaultValues: {
			[priceName]: priceOptions[0]?.path
		}
	})
	const {handleSubmit, control, setValue, watch, reset, register} = methods
	const history = useHistory()

	const onSubmit = (data, event) => {
		event.target.reset()
		if (donation_link)
			history.push(`${donation_link.url}?amt=${data[priceName]}`)
	}

	const priceValue = watch(priceName, priceOptions[0].path)
	const selectedItem = priceOptions?.find(
		(option) => option.path === priceValue
	)

	return (
		<div className={styles()}>
			<ContainerTag>
				<div className={styles('row')}>
					{prices && prices.length > 0 && (
						<form
							ref={register}
							name="ctasupport"
							onSubmit={handleSubmit(onSubmit)}
							className={styles('form')}
						>
							<Controller
								name={priceName}
								control={control}
								defaultValue={priceOptions[0]?.path}
								render={() => (
									<Dropdown
										onChange={(val) => {
											setValue(priceName, val)
										}}
										selected={selectedItem}
										items={priceOptions}
										mod={['boldtext', 'border', 'center']}
									/>
								)}
							/>
							<div className={styles('form-submit')}>
								<Theme.Button as="button">{t.btn_label}</Theme.Button>
							</div>
						</form>
					)}
					<div className={styles('content')}>
						{title_overwrite && (
							<Theme.H3 className={styles('content-title')}>
								{title_overwrite}
							</Theme.H3>
						)}
						{text && (
							<div className={styles('content-text')}>
								<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
							</div>
						)}
						{link?.url && (
							<div className={styles('content-link')}>
								<Theme.Link to={link.url}>
									{link.description || link.title}
								</Theme.Link>
							</div>
						)}
					</div>
				</div>
			</ContainerTag>
		</div>
	)
}
